import type { ConfigureIntegrationResult } from '@cli-types/next-adapter/runtime.js'
import { appendEnvVars } from '@cli-utils/files.js'
import { collectRailwayBucketConfig } from './collect-railway-bucket-config.js'

export async function promptRailwayBucketConfig(cwd: string): Promise<ConfigureIntegrationResult> {
  const collected = await collectRailwayBucketConfig(cwd)
  const envResult = appendEnvVars(cwd, collected.sections, collected.overwriteKeys)

  return {
    configured: true,
    addedEnvKeys: envResult.added,
    updatedEnvKeys: envResult.updated
  }
}
